import { useEffect, useState } from "react";
import { Group } from "@/comn/components";
import { api } from "@/comn";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

type auction = {
    godsDesc: string;
    cstmWrhsCd: string;
    onlnBidStrtDt: string;
    prcssStatNm: string;
    hsCd: string;
    cstmOfcdNm: string;
};

export const TaneswPortalMainAuctionGoods = () => {
    const [foundAuction, setAuction] = useState<auction[]>();
    const navigate = useNavigate();

    const getAuction = async () => {
        try {
            let base = process.env.REACT_APP_API_PTLE || "",
                path = `/api/v1/comn/comn/main/auction`;
            const response = await api.get(base + path);
            const data = response.data.actnGodsList.content;
            setAuction(data);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getAuction();
    }, []);

    return (
        <Group height="100%">
            <Group.Header>
                <h2>
                    Aution Goods
                </h2>
            </Group.Header>
            <Group.Body>
                <div className="board-body popup-list p-[20px] box-border h-auto lg:h-[calc(100%-45px)">
                    <ul>
                        {foundAuction &&
                            foundAuction.map((auction, index) => (
                                <li className="flex flex-col gap-[12px]" key={index}>
                                    <div className="popup-head text-base">
                                        <span className="text-darkgray">{auction.onlnBidStrtDt}</span>
                                        <h4>
                                            <a className="text-primary underline" style={{ cursor: "pointer" }}>
                                                {auction.cstmWrhsCd}
                                            </a>
                                            {auction.hsCd}
                                        </h4>
                                    </div>
                                </li>
                            ))}
                    </ul>
                </div>
            </Group.Body>
        </Group>
    );
};
